"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfirmEmailRegisterState = void 0;
var ConfirmEmailRegisterForm_init_1 = require("@/pages/confirmEmailRegister/states/ConfirmEmailRegisterForm.init");
var ConfirmEmailRegisterFormTranslate_init_1 = require("@/pages/confirmEmailRegister/states/ConfirmEmailRegisterFormTranslate.init");
var LayoutState_init_1 = require("@/pages/common/states/LayoutState.init");
exports.defaultConfirmEmailRegisterState = {
    nameTitle: 'Personal Information',
    nameCaption: 'Enter your name and phone to complete your registration',
    confirmEmailRegisterForm: ConfirmEmailRegisterForm_init_1.defaultConfirmEmailRegisterForm,
    tForm: ConfirmEmailRegisterFormTranslate_init_1.defaultConfirmEmailRegisterFormTranslate,
    isLoading: false,
    dialCodes: LayoutState_init_1.defaultLayoutState.dialCodes,
    salutations: [
        [1, 'Mr'],
        [2, 'Mrs'],
        [3, 'Ms'],
        [4, 'Dr'],
    ],
};
